import useIsMobile from '../../hooks/useIsMobile';
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios';
import PageHeader from '../../components/ui/PageHeader';

const inputSt  = { width: '100%', padding: '8px 12px', border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 13, color: '#111827', backgroundColor: '#fff', outline: 'none', fontFamily: 'inherit' };
const focusSt  = e => { e.target.style.borderColor = '#4F63D2'; e.target.style.boxShadow = '0 0 0 3px rgba(79,99,210,0.1)'; };
const blurSt   = e => { e.target.style.borderColor = '#E5E7EB'; e.target.style.boxShadow = 'none'; };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>{label}</label>
    {children}
  </div>
);

const SectionCard = ({ title, children }) => (
  <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #E5E7EB', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: 16, overflow: 'hidden' }}>
    <div style={{ padding: '13px 18px', borderBottom: '1px solid #F3F4F6', fontWeight: 600, fontSize: 14, color: '#111827' }}>{title}</div>
    <div style={{ padding: 18 }}>{children}</div>
  </div>
);

const NotarySettings = () => {
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const [form, setForm] = useState({
    notary_name: '', notary_title: '', notary_location: '',
    phone: '', email: '', address: '', usd_exchange_rate: '',
  });

  useEffect(() => {
    api.get('/notary-settings').then(res => {
      const d = res.data;
      setForm({ notary_name: d.notary_name || '', notary_title: d.notary_title || '', notary_location: d.notary_location || '', phone: d.phone || '', email: d.email || '', address: d.address || '', usd_exchange_rate: d.usd_exchange_rate || '' });
      if (d.logo_url) setLogoUrl(d.logo_url);
    }).finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.put('/notary-settings', form); toast.success('Datos guardados correctamente'); }
    catch { toast.error('Error al guardar'); } finally { setSaving(false); }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setUploadingLogo(true);
    try {
      const fd = new FormData(); fd.append('logo', file);
      const res = await api.post('/notary-settings/logo', fd);
      setLogoUrl(res.data.logo_url); toast.success('Logo actualizado');
    } catch { toast.error('Error al subir logo'); }
    finally { setUploadingLogo(false); e.target.value = ''; }
  };

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
      <div style={{ width: 28, height: 28, border: '3px solid #EEF0FB', borderTopColor: '#4F63D2', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
    </div>
  );

  return (
    <div>
      <PageHeader title="Datos de la Notaría" subtitle="Información que aparece en los presupuestos y documentos" />

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '220px 1fr', gap: 16, alignItems: 'start' }}>
        {/* Logo */}
        <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #E5E7EB', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
          <div style={{ padding: '13px 18px', borderBottom: '1px solid #F3F4F6', fontWeight: 600, fontSize: 14, color: '#111827' }}>Logo</div>
          <div style={{ padding: '18px', textAlign: 'center' }}>
            <div style={{ width: '100%', aspectRatio: '1', border: '2px dashed #E5E7EB', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, overflow: 'hidden', backgroundColor: '#F9FAFB' }}>
              {logoUrl ? (
                <img src={logoUrl} alt="Logo notaría" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', padding: 8 }} />
              ) : (
                <div style={{ textAlign: 'center', color: '#9CA3AF' }}>
                  <svg style={{ width: 36, height: 36, margin: '0 auto 6px', display: 'block' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span style={{ fontSize: 12 }}>Sin logo</span>
                </div>
              )}
            </div>
            <label style={{ display: 'block', padding: '7px 14px', borderRadius: 8, border: '1.5px solid #4F63D2', backgroundColor: '#EEF0FB', color: '#4F63D2', fontWeight: 600, fontSize: 13, cursor: 'pointer', textAlign: 'center' }}>
              {uploadingLogo ? 'Subiendo...' : 'Subir Logo'}
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoUpload} disabled={uploadingLogo} />
            </label>
            <p style={{ margin: '8px 0 0', fontSize: 11, color: '#9CA3AF' }}>PNG, JPG. Máx 2MB</p>
          </div>
        </div>

        {/* Datos */}
        <form onSubmit={handleSubmit}>
          <SectionCard title="Información de la Notaría">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' }}>
              <Field label="Nombre del Notario">
                <input type="text" name="notary_name" value={form.notary_name} onChange={handleChange} placeholder="Lic. Jorge Jaime Cruz Hernandez" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </Field>
              <Field label="Título / Notaría">
                <input type="text" name="notary_title" value={form.notary_title} onChange={handleChange} placeholder="Notaría Pública 84" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </Field>
              <Field label="Ubicación">
                <input type="text" name="notary_location" value={form.notary_location} onChange={handleChange} placeholder="Playa del Carmen, Quintana Roo" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </Field>
              <Field label="Teléfono">
                <input type="text" name="phone" value={form.phone} onChange={handleChange} placeholder="(984) 109 3550" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </Field>
              <Field label="Correo electrónico">
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="notaria@ejemplo.mx" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </Field>
              <Field label="Tipo de cambio USD">
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 13, color: '#9CA3AF', fontWeight: 600 }}>$</span>
                  <input type="number" name="usd_exchange_rate" value={form.usd_exchange_rate} onChange={handleChange} placeholder="17.00" step="0.0001" min="0" style={{ ...inputSt, flex: 1 }} onFocus={focusSt} onBlur={blurSt} />
                  <span style={{ fontSize: 12, color: '#9CA3AF', whiteSpace: 'nowrap' }}>MXN/USD</span>
                </div>
                <p style={{ margin: '4px 0 0', fontSize: 11, color: '#9CA3AF' }}>Se usa para convertir presupuestos a dólares</p>
              </Field>
              <div style={{ gridColumn: '1 / -1' }}>
                <Field label="Dirección completa">
                  <textarea name="address" rows={2} value={form.address} onChange={handleChange} placeholder="Av. 28 de Julio, Mza-16 Lt-1 Local #1..." style={{ ...inputSt, resize: 'vertical' }} onFocus={focusSt} onBlur={blurSt} />
                </Field>
              </div>
            </div>
          </SectionCard>

          <button type="submit" disabled={saving}
            style={{ padding: '9px 22px', borderRadius: 8, border: 'none', backgroundColor: '#4F63D2', color: '#fff', fontWeight: 600, fontSize: 14, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NotarySettings;
